export const STORAGE_KEYS = {
  TOKEN: "nub_vision_2_admin_paneltoken",
};

export const FIGTREE_FONT_FAMILY = "Figtree";

export const LOGIN_PAGE_BACKGROUND_IMAGE = require("../../assets/images/login-new-background-img.jpg");

export const ADMIN_PANEL_EMAIL = "admin@nubvision.com"
export const ADMIN_PANEL_PASSWORD = "5O1Rwod@1@r64tk1%8WjYj"